import React from 'react'
import cx from 'classnames'

import styles from './AnswerLayout.module.css'

import BackButton from '../../components/BackButton'
import Tips, { Tip } from '../../components/Tips'

const AnswerLayout = ({ children, ...rest }) => {
  return (
    <div className={styles.Container} {...rest}>
      {children}
    </div>
  )
}

export const AnswerMain = ({ children, ...rest }) => {
  return (
    <div className={styles.MainContent} {...rest}>
      <BackButton />
      <div className={styles.AnswerContent}>{children}</div>
    </div>
  )
}

export const AnswerSidebar = ({ children, ...rest }) => {
  return (
    <div className={styles.SidebarContent} {...rest}>
      <p>Manage</p>
      <div className={styles.ManageContainer}>{children}</div>
      <Tips title='How answers work'>
         <Tip>
            Once you have created an answer, you can insert it in any of your Bots using the 'Show Answer' action in the
            flow builder
          </Tip>
          <Tip>Answers are automatically parsed by HappyFox Chatbot for key words and phrases</Tip>
          <Tip>
            Your answers will also be shown to users as search results when they type their question directly during a
            conversation.
          </Tip>
        </Tips>
    </div>
  )
}

export const AnswerTitle = ({ className, children, ...rest }) => {
  return (
    <div className={cx(className, styles.Title)} {...rest}>
      {children}
    </div>
  )
}

export default AnswerLayout
